// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-detail-container2 {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;
  height: 100%;
  max-height: 100%;
  overflow: auto;
  bottom: 0;
  box-shadow: -0.35vw -0.35vw 17.35vw 0 rgba(255, 255, 255, 0.0196078431);
  background: radial-gradient(100% 100% at 0% 0%, rgba(53, 38, 38, 0.4) 0%, rgba(38, 26, 26, 0.1) 100%);
  backdrop-filter: blur(2.92vw);
  width: 25vw;
  min-width: 320px;
  display: flex;
  flex-direction: column;
}
.product-detail-container2 .product-image-3dModel {
  position: relative;
  height: 275px;
}
.product-detail-container2 .product-image-3dModel .product-big-img {
  text-align: center;
}
.product-detail-container2 .product-image-3dModel .product-big-img img {
  width: 100%;
  height: 275px;
  transition: ease-in all 0.2s;
  object-fit: contain;
}
.product-detail-container2 .product-image-3dModel .close-icon svg {
  width: 22px;
  height: 22px;
}
.product-detail-container2 .product-image-3dModel .close-icon svg path {
  fill: #fff;
}
.product-detail-container2 .product-image-3dModel .music_button {
  top: unset !important;
  bottom: 15px !important;
  width: 30px !important;
  height: 30px !important;
  cursor: pointer;
}
.product-detail-container2 .product-detail {
  padding: 0 15px 10px;
  box-sizing: content-box;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.product-detail-container2 .product-detail .img-view-model {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 7px;
}
.product-detail-container2 .product-detail .img-view-model .product-small-img {
  display: flex;
  gap: 5px;
  max-width: 60%;
  overflow-x: scroll;
  height: 65px;
}
.product-detail-container2 .product-detail .img-view-model .product-small-img > div {
  width: 55px;
  height: 55px;
  cursor: pointer;
}
.product-detail-container2 .product-detail .img-view-model .product-small-img > div img {
  width: 55px;
  height: 55px;
  object-fit: cover;
}
.product-detail-container2 .product-detail .text-3d {
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
}
.product-detail-container2 .product-detail .text-3d p {
  font-size: 0.95vw;
  color: #ffffff;
  font-weight: 500;
  border-bottom: 1px solid #fff;
}
.product-detail-container2 .product-detail .prod-description > p {
  color: #ffffff;
  font-size: 1.11vw;
  line-height: 1.33vw;
  font-weight: 500;
  letter-spacing: 2%;
  margin: 1.11vw 0;
  max-height: 75px;
  height: 100%;
  overflow-y: scroll;
}
.product-detail-container2 .product-detail .prod-price > p {
  color: #ffffff;
  font-size: 1.53vw;
  line-height: 1.53vw;
  font-weight: 700;
  /* margin: 2.22vw 0 1.11vw 0;
    margin: 1.11vw 0 0.5vw; */
}
.product-detail-container2 .product-detail .title {
  font-size: 1.05vw;
  font-weight: 500;
  color: #fff;
}
.product-detail-container2 .product-detail .product-detail-title {
  font-size: 1.53vw;
  color: #fff;
}
.product-detail-container2 .product-detail .prod-button-container {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 10px;
  gap: 1px;
}
.product-detail-container2 .product-detail .prod-button-container button {
  font-size: 1.25vw;
  font-weight: 400;
  line-height: 1.25vw;
}
.product-detail-container2 .product-detail .prod-button-container .prod-count {
  width: 13.12vw;
  background-color: transparent;
  border: 1px solid #ffffff;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1vw;
  justify-content: space-between;
  width: 48%;
}
.product-detail-container2 .product-detail .prod-button-container .prod-count .count {
  padding: 10px;
}
.product-detail-container2 .product-detail .prod-button-container .prod-count span {
  display: flex;
}
.product-detail-container2 .product-detail .prod-button-container .add-to-bag {
  width: 17vw;
  background-color: #fff;
  border: 1px solid #ffffff;
  color: #3f3636;
  cursor: pointer;
  width: 48%;
}
.product-detail-container2 ::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  cursor: pointer;
}
.product-detail-container2 ::-webkit-scrollbar-thumb {
  background: radial-gradient(100% 100% at 0% 0%, rgba(255, 255, 255, 0.57) 70%, rgba(255, 255, 255, 0.81) 100%);
  box-shadow: -5px -5px 250px 0px rgba(255, 255, 255, 0.0196078431) inset;
  border-radius: 1.46vw;
  cursor: pointer;
}
.product-detail-container2 ::-webkit-scrollbar-track {
  background: transparent;
  box-shadow: -5px -5px 250px 0px rgba(255, 255, 255, 0.0196078431) inset;
}

@media only screen and (max-width: 768px) {
  .product-detail-container2 h3 {
    font-size: 20px !important;
  }
  .product-detail-container2 h3.title {
    line-height: unset;
    font-size: 16px !important;
  }
  .product-detail-container2 p,
  .product-detail-container2 button {
    font-size: 16px !important;
    line-height: unset !important;
  }
  .product-detail-container2 button {
    line-height: unset !important;
    padding: 10px 0;
  }
  .product-detail-container2 .product-image-3dModel {
    height: 175px;
  }
  .product-detail-container2 .product-image-3dModel .product-big-img img {
    height: 175px;
  }
  .product-detail-container2 .product-image-3dModel .model-3d > div {
    height: 175px !important;
  }
}
@media only screen and (max-width: 426px) {
  .product-detail-container2 {
    width: 100%;
  }
  .product-detail-container2 button {
    padding: 10px 5px;
  }
}`, "",{"version":3,"sources":["webpack://./src/style/components/three/ProductDetails2.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,uEAAA;EACA,qGAAA;EAKA,6BAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAHF;AAKE;EACE,kBAAA;EACA,aAAA;AAHJ;AAII;EACE,kBAAA;AAFN;AAGM;EACE,WAAA;EACA,aAAA;EACA,4BAAA;EACA,mBAAA;AADR;AAMM;EACE,WAAA;EACA,YAAA;AAJR;AAKQ;EACE,UAAA;AAHV;AAQI;EACE,qBAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;AANN;AASE;EACE,oBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAPJ;AASI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAPN;AAQM;EACE,aAAA;EACA,QAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;AANR;AAQQ;EACE,WAAA;EACA,YAAA;EACA,eAAA;AANV;AAQU;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AANZ;AAYI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAVN;AAWM;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,6BAAA;AATR;AAaI;EACE,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAXN;AAaI;EACE,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA;6BAAA;AAVN;AAcI;EACE,iBAAA;EACA,gBAAA;EACA,WAAA;AAZN;AAeI;EACE,iBAAA;EACA,WAAA;AAbN;AAgBI;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;EAGA,QAAA;AAhBN;AAkBM;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;AAhBR;AAmBM;EACE,cAAA;EACA,6BAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAGA,cAAA;EACA,8BAAA;EACA,UAAA;AAnBR;AAqBQ;EACE,aAAA;AAnBV;AAsBQ;EACE,aAAA;AApBV;AAwBM;EACE,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;AAtBR;AA0BE;EACE,UAAA;EACA,WAAA;EACA,eAAA;AAxBJ;AA0BE;EACE,8GAAA;EAKA,uEAAA;EACA,qBAAA;EACA,eAAA;AA5BJ;AA8BE;EAME,uBAAA;EACA,uEAAA;AAjCJ;;AAqCA;EAEI;IACE,0BAAA;EAnCJ;EAoCI;IACE,kBAAA;IACA,0BAAA;EAlCN;EAsCE;;IAEE,0BAAA;IACA,6BAAA;EApCJ;EAsCE;IACE,6BAAA;IACA,eAAA;EApCJ;EAuCE;IACE,aAAA;EArCJ;EAuCM;IACE,aAAA;EArCR;EAwCI;IACE,wBAAA;EAtCN;AACF;AAoDA;EACE;IACE,WAAA;EAlDF;EAmDE;IACE,iBAAA;EAjDJ;AACF","sourcesContent":[".product-detail-container2 {\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 10;\n  height: 100%;\n  max-height: 100%;\n  overflow: auto;\n  bottom: 0;\n  box-shadow: -0.35vw -0.35vw 17.35vw 0 rgba(255, 255, 255, 0.0196078431);\n  background: radial-gradient(\n    100% 100% at 0% 0%,\n    rgba(53, 38, 38, 0.4) 0%,\n    rgba(38, 26, 26, 0.1) 100%\n  );\n  backdrop-filter: blur(2.92vw);\n  width: 25vw;\n  min-width: 320px;\n  display: flex;\n  flex-direction: column;\n\n  .product-image-3dModel {\n    position: relative;\n    height: 275px;\n    .product-big-img {\n      text-align: center;\n      img {\n        width: 100%;\n        height: 275px;\n        transition: ease-in all 0.2s;\n        object-fit: contain;\n      }\n    }\n\n    .close-icon {\n      svg {\n        width: 22px;\n        height: 22px;\n        path {\n          fill: #fff;\n        }\n      }\n    }\n\n    .music_button {\n      top: unset !important;\n      bottom: 15px !important;\n      width: 30px !important;\n      height: 30px !important;\n      cursor: pointer;\n    }\n  }\n  .product-detail {\n    padding: 0 15px 10px;\n    box-sizing: content-box;\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n\n    .img-view-model {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      margin-bottom: 7px;\n      .product-small-img {\n        display: flex;\n        gap: 5px;\n        max-width: 60%;\n        overflow-x: scroll;\n        height: 65px;\n\n        & > div {\n          width: 55px;\n          height: 55px;\n          cursor: pointer;\n\n          img {\n            width: 55px;\n            height: 55px;\n            object-fit: cover;\n          }\n        }\n      }\n    }\n\n    .text-3d {\n      display: flex;\n      align-items: center;\n      gap: 5px;\n      cursor: pointer;\n      p {\n        font-size: 0.95vw;\n        color: #ffffff;\n        font-weight: 500;\n        border-bottom: 1px solid #fff;\n      }\n    }\n\n    .prod-description > p {\n      color: #ffffff;\n      font-size: 1.11vw;\n      line-height: 1.33vw;\n      font-weight: 500;\n      letter-spacing: 2%;\n      margin: 1.11vw 0;\n      max-height: 75px;\n      height: 100%;\n      overflow-y: scroll;\n    }\n    .prod-price > p {\n      color: #ffffff;\n      font-size: 1.53vw;\n      line-height: 1.53vw;\n      font-weight: 700;\n      /* margin: 2.22vw 0 1.11vw 0;\n        margin: 1.11vw 0 0.5vw; */\n    }\n\n    .title {\n      font-size: 1.05vw;\n      font-weight: 500;\n      color: #fff;\n    }\n\n    .product-detail-title {\n      font-size: 1.53vw;\n      color: #fff;\n    }\n\n    .prod-button-container {\n      display: flex;\n      justify-content: space-between;\n      gap: 10px;\n      margin-top: 10px;\n\n      //check\n      gap: 1px;\n\n      button {\n        font-size: 1.25vw;\n        font-weight: 400;\n        line-height: 1.25vw;\n      }\n\n      .prod-count {\n        width: 13.12vw;\n        background-color: transparent;\n        border: 1px solid #ffffff;\n        color: #fff;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        //check\n        padding: 0 1vw;\n        justify-content: space-between;\n        width: 48%;\n\n        .count {\n          padding: 10px;\n        }\n\n        span {\n          display: flex;\n        }\n      }\n\n      .add-to-bag {\n        width: 17vw;\n        background-color: #fff;\n        border: 1px solid #ffffff;\n        color: #3f3636;\n        cursor: pointer;\n        width: 48%;\n      }\n    }\n  }\n  ::-webkit-scrollbar {\n    width: 5px;\n    height: 5px;\n    cursor: pointer;\n  }\n  ::-webkit-scrollbar-thumb {\n    background: radial-gradient(\n      100% 100% at 0% 0%,\n      rgba(255, 255, 255, 0.57) 70%,\n      rgba(255, 255, 255, 0.81) 100%\n    );\n    box-shadow: -5px -5px 250px 0px #ffffff05 inset;\n    border-radius: 1.46vw;\n    cursor: pointer;\n  }\n  ::-webkit-scrollbar-track {\n    // background: radial-gradient(\n    //   100% 100% at 0% 0%,\n    //   rgba(255, 255, 255, 0.57) 70%,\n    //   rgba(255, 255, 255, 0.81) 100%\n    // );\n    background: transparent;\n    box-shadow: -5px -5px 250px 0px #ffffff05 inset;\n  }\n}\n\n@media only screen and (max-width: 768px) {\n  .product-detail-container2 {\n    h3 {\n      font-size: 20px !important;\n      &.title {\n        line-height: unset;\n        font-size: 16px !important;\n      }\n    }\n\n    p,\n    button {\n      font-size: 16px !important;\n      line-height: unset !important;\n    }\n    button {\n      line-height: unset !important;\n      padding: 10px 0;\n    }\n\n    .product-image-3dModel {\n      height: 175px;\n      .product-big-img {\n        img {\n          height: 175px;\n        }\n      }\n      .model-3d > div {\n        height: 175px !important;\n      }\n    }\n\n    // .size-container {\n    //   .container-list {\n    //     button {\n    //       font-size: 14px !important;\n    //       padding: 5px 6px;\n    //     }\n    //   }\n    // }\n  }\n}\n\n@media only screen and (max-width: 426px) {\n  .product-detail-container2 {\n    width: 100%;\n    button {\n      padding: 10px 5px;\n    }\n  }\n}\n\n// @media only screen and (max-width: 426px) {\n\n//   .product-image-mobile{\n//     display: block!important;\n//     margin-top: 15px;\n//     position: relative;\n//     .close-icon{\n//       position: absolute;\n//       width: 20px;\n//       height: 20px;\n//       border-radius: 50%;\n//       display: flex\n//   ;\n//       justify-content: center;\n//       align-items: center;\n//       cursor: pointer;\n//       z-index: 3;\n//       padding: 5px;\n//       border: 1px solid;\n//       top: 10px;\n//       right: 10px;\n//       svg{\n//         cursor: pointer;\n//     width: 15px;\n//     height: 15px;\n//     path{\n//       fill: #000;\n//       opacity: 1;\n//     }\n//       }\n//     }\n//     .music_icon{\n//       top: auto !important;\n//       bottom: 10px;\n//     }\n//     .slick-slide img{\n//       width: 100% !important;\n//       max-height: 250px !important;\n//       height: 100%!important;\n//         object-fit: cover;\n//     }\n//     .slick-dots{\n//       bottom: 0;\n//     }\n//   }\n//   .product-detail-container {\n//     width: 100%;\n\n//     .product-image{\n//       display: none;\n//     }\n\n//     .product-detail-wrapper .product-image .product-big-img{\n//       min-width: 10px;\n//       height: auto;\n//       aspect-ratio: 1;\n//     }\n\n//     .prod-price{\n//       line-height: unset;\n//     }\n\n//     .product-size{\n//       margin: 10px 0;\n//     }\n//   }\n// }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
